import { SET_CONTENTFUL } from '../actions/types';
import update from 'immutability-helper';

const contentfulInitialState = {
  continent:[],
  category:[],
  products:[],
  filteredResults:[],
  countryData:[]
}

export function Contentful(state = contentfulInitialState, action){
  switch (action.type) {
    case SET_CONTENTFUL:
      return update(state, {
        continent: {$set:action.payload.continent},
        category: {$set:action.payload.category},
        products: {$set:action.payload.products},
        filteredResults: {$set:action.payload.filteredResults},
        countryData: {$set:action.payload.countryData}
      })
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_contentful.js